

import React, { useEffect, useState } from "react";
import { CiBitcoin } from "react-icons/ci";
import { FaCircle } from "react-icons/fa";
import { FaCircleQuestion } from "react-icons/fa6";
import { FiUsers } from "react-icons/fi";
import { RiLoader3Fill } from "react-icons/ri";
import { setPartnerDeatils, setselectedComponent, setUserLevel } from "../Store/UserSlice";
import { useDispatch, useSelector } from "react-redux";
import { MdLockPerson } from "react-icons/md";
import axios from "axios";
import CoinIcon from '../../asstes/Tether-USDT-icon.png'
import LockIcons from '../../asstes/shield.png'
import { useAccount, useBalance, useReadContract, useWaitForTransactionReceipt, useWriteContract } from "wagmi";
import contAbi from '../../contracts/ContractAbi.json'
import { contractAbi, contractAddress, tokenAbi, tokenAddress } from "../../contracts";
import { writeContract } from "@wagmi/core";
import { waitForTransaction } from '@wagmi/core'
import { toast } from "react-toastify";
import { SiBitcoinsv } from "react-icons/si";


const Forsagex3Page = ({ setdeshborddata }) => {

  const { data: hash, writeContractAsync } = useWriteContract();
  const { address, isConnected, isDisconnected } = useAccount();

  const dispatch = useDispatch();
  const UserData = useSelector((state) => state.user.UserData);
  const ActiveSlot = UserData?.user?.totalActiveSlot;
  const UserLevel = useSelector(state => state.user.UserLevel)
  const ApiUrl = process.env.REACT_APP_API;
  const UserId = useSelector(state => state.user.UserInputid)
  const dataLevel = [
    { "Lvl 1": { num: 10, usernum: (UserData?.partners?.[0] || 0) } },
    { "Lvl 2": { num: 25, usernum: (UserData?.partners?.[1] || 0) } },
    { "Lvl 3": { num: 50, usernum: (UserData?.partners?.[2] || 0) } },
    { "Lvl 4": { num: 110, usernum: (UserData?.partners?.[3] || 0) } },
    { "Lvl 5": { num: 225, usernum: (UserData?.partners?.[4] || 0) } },
    { "Lvl 6": { num: 350, usernum: (UserData?.partners?.[5] || 0) } },
    { "Lvl 7": { num: 575, usernum: (UserData?.partners?.[6] || 0) } },
    { "Lvl 8": { num: 850, usernum: (UserData?.partners?.[7] || 0) } },
    { "Lvl 9": { num: 1275, usernum: (UserData?.partners?.[8] || 0) } },
    { "Lvl 10": { num: 2550, usernum: (UserData?.partners?.[9] || 0) } },
  ];



  const [BothHash, setBothHash] = useState({
    ApproveHash: "",
    LvelsHash: ""
  })

  const GetPartnerDetails = async (id, item) => {
    if (id) {
      try {
        const response = await axios.get(`${ApiUrl}/users/partners-details/${id}/${item + 1}`)
        console.log("PartnerDeatils", response.data)
        dispatch(setPartnerDeatils(response.data))

      } catch (error) {
        console.log("PartnerDeatils", error)
      }
    }
  }

  const HandleClick = (item, num) => {
    console.log("item", item);
    dispatch(setselectedComponent("Forsagex3Details"));
    GetPartnerDetails(UserId, item)
    dispatch(setUserLevel({
      Levels: item + 1,
      LevelAmount: num,
      UserId: UserId
    }))
  };



  const [tnxhash, settnxhash] = useState('')
const [BuyLevel, setBuyLevel] = useState(false)

  const result = useReadContract({
    abi: contractAbi,
    address: contractAddress,
    functionName: 'levelPrice',
    args: [UserLevel.Levels]
  });

  console.log("UserLevels", UserData.Levels)

  const bal = useBalance({
    address: address,
    token: tokenAddress,
  });

  console.log("Hash", hash)
  console.log("UserDataUserDataUserData", UserData?.user?.userAddress, address)
  console.log("userlevelsuserlevels", UserLevel)


  const HandleBuyLevel = (index) => {
    dispatch(setUserLevel({ Levels: index }))
    setBuyLevel(true)
  }

  const ButLevel = async () => {
    if(BuyLevel){
      if (UserData.user.userAddress === address) {
        try {
          const outcome = await writeContractAsync({
            abi: tokenAbi,
            address: tokenAddress,
            functionName: "approve",
            args: [contractAddress, result.data],
          });
          if (outcome) {
            try {
              const Sucess = await writeContractAsync({
                abi: contAbi,
                address: contractAddress,
                functionName: "buyNewLevel",
                args: [UserLevel.Levels],
              });
              settnxhash(Sucess);
              if (Sucess) {
                apicall();
              }
              console.log("Transaction successful:", Sucess);
            } catch (error) {
              console.log("Error in Levels Ftn:", error);
            }
          }
        } catch (error) {
          console.log("appapp", error);
        }
      } else {
        console.log("errrrr");
        toast.error('You are Not the Owner of that Account');
      }
    }
  };



  useEffect(() => {
    if (result?.data) {
      ButLevel();
    } else {
      console.log("errr")
    }
  }, [result?.data]);


  const apicall = async () => {
    const data = {
      userAddress: address,
      level: UserLevel.Levels,
      txnHash: tnxhash,
    };
    try {
      const response = await axios.post(`${ApiUrl}/users/buyNewLevel`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      console.log("res", response)
    }
    catch (error) {
      console.log(error)
    }
  }

  return (
    <>

      <div className="main-div-forsagex3page bg-[#111111]">
        <div className="div-forsagex3page ">
          {dataLevel?.map((item, index) => {
            const levelKey = Object.keys(item)[0];
            const { num, usernum, loaduser } = item[levelKey];
            const isActive = index < ActiveSlot;

            return (
              <div className="Livdib_animation">
                <div
                key={index}
                className={`Lvldiv    ${isActive ? "" : "Lvldiv_unvisible LevelDiv_size"}`}
                onClick={() => isActive ? HandleClick(index, num) : HandleBuyLevel(index + 1)}
              >
                <div className="Lvlheader ">
                  <span className="lvl-span-forsagex3page ">{levelKey}</span>
                  <span className="lvlheadr-span1 text">
                    {/* <SiBitcoinsv className="span1-icon  bg-white rounded-full"  size={30} /> */}
                    <img src={CoinIcon} className="span1-icon  bg-white rounded-full" width={"22px"}></img>
                    {num}
                  </span>
                </div>

                {isActive ? (
                  <div className="Lvlbody">
                    <div className="lvlbox"></div>
                    <div className="lvlbox"></div>
                    <div className="lvlbox"></div>
                  </div>
                ) : (
                  <div className="Lvlbody inactive ">
                    <div className="inactive-lock-div">
                      <MdLockPerson color="white" />
                      {/* <img src={LockIcons} width={"50px"}></img> */}
                      </div>
                    {/* <div className="lvlbox inactivecrycle"></div>
                    <div className="lvlbox inactivecrycle"></div>
                    <div className="lvlbox inactivecrycle"></div> */}
                  </div>
                )}



                <div className="lvlfooter">
                  <span className="lvl-span-forsagex3page text-white">
                    {usernum !== 0 && <FiUsers />}
                    {usernum !== 0 && usernum}
                  </span>

                </div>
              </div>
              </div>
            );
          })}
        </div>
      
        <div className="forsagex3-footer Box_Backgrounds p-4 ">
          <span className="forsagex3-footer-span">
            <FaCircle className="FaCircle Direct-partner-icon" /> Direct partner
          </span>
          <span className="forsagex3-footer-span">
            <FaCircle className="FaCircle Gift"  /> Gift
          </span>
          <span className="forsagex3-footer-span">
            <FiUsers className="FaCircle " /> Partners on level
          </span>
          <span className="forsagex3-footer-span">
            <RiLoader3Fill className="FaCircle " /> Level Cycle
          </span>
          <div className="Marketing-legend">
            <span>
              <FaCircleQuestion />
            </span>{" "}
            <span>Marketing legend</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Forsagex3Page;
